/**
 * Job facet fields are usually string arrays but can arrive as a single string from
 * some crawlers or legacy records. Returns a safe array for iteration.
 */
export function coerceStringArrayField(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string' && item.length > 0);
  }
  if (typeof value === 'string' && value.length > 0) {
    return [value];
  }
  return [];
}
